<template>
    <div class="main-phrase">
        <el-row>
            <el-button @click="showPhraseDialog(null)">添加热评</el-button>
        </el-row>
        <el-row>
            <el-table
                :data="pageInfo.records"
                style="width: 90%">
                <el-table-column
                    width="50"
                    prop="id"
                    label="编号">
                </el-table-column>
                <el-table-column
                    width="150"
                    prop="source"
                    label="作者">
                </el-table-column>
                <el-table-column
                    label="内容">
                    <el-popover 
                        slot-scope="scope"
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :content="scope.row.content">
                        <span slot="reference">{{ scope.row.content }}</span>
                    </el-popover>
                </el-table-column>
                <el-table-column
                    width="350"
                    label="封面">
                    <el-popover 
                        slot-scope="scope"
                        placement="top-start"
                        width="150"
                        trigger="hover">
                        <img :src="scope.row.cover" style="width:150px;"/>
                        <span slot="reference">{{ scope.row.cover }}</span>
                    </el-popover>
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    label="更新时间"/>
                <el-table-column
                    width="250"
                    fixed="right"
                    label="操作">
                    <template slot-scope="scope">
                        <el-row :gutter="10">
                            <el-col :span="6">
                                <el-button type="primary" size="mini" @click="showPhraseDialog(scope.row)">修改</el-button>
                            </el-col>
                            <el-col :span="6">
                                <el-popconfirm
                                @onConfirm="removePhrase(scope.row.id)"
                                title="确定删除?">
                                <el-button type="danger" size="mini" slot="reference">删除</el-button>
                                </el-popconfirm>
                            </el-col>
                        </el-row>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-row style="margin-top: 15px;">
            <el-pagination
                layout="prev, pager, next"
                 @current-change="findPhrases"
                :current-page.sync="pageInfo.current"
                :total="pageInfo.total">
            </el-pagination>
        </el-row>

        <el-dialog
            :title="phrase.dialogTitle"
            :visible.sync="phraseDialog"
            @closed = "phraseDialogClosed"
            width="30%">
            <el-row type="flex" justify="center">
                <el-col :span="21">
                    <el-input v-model="phrase.source" 
                    :clearable="true"
                    placeholder="作者/来源"></el-input>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center">
                <el-col :span="21">
                    <el-input v-model="phrase.content" :clearable="true" placeholder="内容"></el-input>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center">
                <el-col :span="21">
                    <el-input v-model="phrase.cover" :clearable="true" placeholder="封面"></el-input>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center">
                <el-upload
                    ref="cover-upload"
                    action="#"
                    list-type="picture-card"
                    :multiple = "false"
                    :show-file-list="false"
                    :http-request = "fileUpload"
                    :on-remove = "removeFile"
                    style="width:150px;height:auto;line-height:0">
                    <img v-if="phrase.cover" slot="default" :src="phrase.cover" style="width:100%;" >
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-row>

            <span slot="footer" class="dialog-footer">
                <el-button @click="phraseDialog = false">取 消</el-button>
                <el-button type="primary" @click="savePhrase">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {queryPhrases,updatePhrase,deletePhrase} from "@/api/phrase.js"
import {upload,deleteFile} from "@/api/file.js"

export default {
    name: 'Phrase',
    data() {
        return {
            pageInfo: {current: 1},
            phrase: {dialogTitle: "", cover: ""},
            phraseDialog: false,
            
        }
    },
    mounted() {
        this.findPhrases()
    },
    methods: {
        findPhrases(){
            queryPhrases({current: this.pageInfo.current}).then(data=>{
                this.pageInfo = data.data
                if(this.pageInfo.current>this.pageInfo.pages){
                    this.pageInfo.current = this.pageInfo.pages
                    this.findPhrases()
                }
            })
        },
        showPhraseDialog(phrase){
            if(phrase){
                this.phrase=phrase
                this.phrase.dialogTitle = "修改热评"
            }else{
                this.phrase.dialogTitle = "新增热评"
                this.phrase.coverList = []
            }
            this.phraseDialog = true
        },
        phraseDialogClosed(){
            this.phrase = this.$options.data().phrase
        },
        savePhrase(){
            delete this.phrase.createTime
            delete this.phrase.updateTime
            updatePhrase(this.phrase).then(()=>{
                this.phraseDialog = false
                this.findPhrases()
            })
        },
        removePhrase(id){
            deletePhrase(id).then(()=>{
                this.findPhrases()
            })
        },
        fileUpload(fileObj){
            let param = new FormData();
            param.append('file', fileObj.file);
            upload(param).then((data)=>{
                this.phrase.cover = "http://joburgess.cn"+data.data
            })
        },
        removeFile(file){
            console.log(file)
            deleteFile(file.url).then(()=>{})
        }
    }
}
</script>

<style lang="scss">
    .main-phrase{
        .el-dialog .el-row{
            margin-bottom: 15px;
        }
        .cell{
            overflow: hidden;
            white-space: nowrap;
        }
        .el-upload--picture-card{
            width:150px;
            height:auto;
            line-height: 0;
        }
    }
</style>